<script setup lang="ts">
import { getCurrentInstance } from 'vue';

import CartWidget from '@/components/cart/CartWidget.vue';
import { i18n } from '@/shared-instance';

const props = defineProps<{
  top?: string;
  right?: string;
}>();

i18n.install(getCurrentInstance()!.appContext.app);
</script>

<template>
  <CartWidget :top="props.top ? props.top : null" :right="props.right ? props.right : null" />
</template>
